export default {
  welcome: 'Hola, {{name}}',
  needHelp: '¿Necesitas ayuda?'
}
